import React from "react";
import "../../../css/YearPaid.css";
import mobility from "../../../img/ride.png";

interface YearPaidProps {
  YearPaid: number;
}

const YearPaid = ({ YearPaid }: YearPaidProps) => {
  return (
    <div className="year_paid_container">
      <div className="year_paid_display">
        <img className="mobility" src={mobility} />
        <div className="year_paid_title">今期の支払金額</div>
      </div>
      <div className="year_paid_of">
        {YearPaid.toLocaleString()}
        <span className="unit">円</span>
      </div>
    </div>
  );
};

export default YearPaid;
